import { createContext, useContext } from 'react';

export interface Country {
  id: string;
  label: string;
  value: string;
}

type CountryContextType = {
  loading: boolean;
  countries: Country[] | undefined;
};

export const CountryContext = createContext<CountryContextType | undefined>(undefined);

export const useCountries = (): CountryContextType => {
  const context = useContext(CountryContext);
  if (context === undefined) {
    throw new Error('useCountries must be used within a CountryProvider');
  }
  return context;
};
